// A/B股比价
import { Observer } from "mobx-react-lite"
import React from "react"
import { QuestionIcon } from "../../shared/icon"
import { PageType } from "../../shared/pagetype"
import { single_quote, quote_item_name } from "../../shared/quotedata/index"
import { store } from "./store"

export function ABPrice(props: { pagetype: PageType }) {

  const clickAB = (data:any)=>{
    window.location.href = `/quote/stock/${data.f270}.${data.f269}.html`;
  }

  return (
    <Observer>
      {() => (
        <>
          {store.StockDetail && store.StockDetail.f269 && store.StockDetail.f269 != '-' && (props.pagetype == PageType.沪深A股) && (
            <div className="ah-notice">
              <div className="ah-container" onClick={()=>clickAB(store.StockDetail)}>
                <p>
                  B股报价：
                  {single_quote[quote_item_name["A/B股报价"]](store.StockDetail).element}
                </p>
                <p>
                  <QuestionIcon/>
                  (A/B)比价={single_quote[quote_item_name["(A/B)比价"]](store.StockDetail).element}
                  <i className="arrow-right-new"></i>
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </Observer>
  )
}
